module.exports = __webpack_public_path__ + "static/media/nrJcX8qfUg.20270311.jpg";